import { useFormContext } from '@context/FormContext';
import Spinner from '../Spinner/Spinner';

const isWidget = process.env.REACT_APP_IS_WIDGET;

const OverlaySpinner = ({ size = 'sm' }: { size?: 'sm' | 'lg' }) => {
  const { widgetInitVariables } = useFormContext();
  return (
    <div
      className="iLendingCDX-spinner-overlay"
      style={{
        borderRadius: widgetInitVariables?.branding?.roundCorners ? '8px' : '0px',
        position: isWidget ? 'absolute' : 'fixed',
      }}
    >
      <div className="iLendingCDX-spinner-container">
        <Spinner size={size} />
      </div>
    </div>
  );
};

export default OverlaySpinner;
